import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { INSERT_CONTRACT } from "../../../api-setup/api-endpoints";

/**
 * Insert a new contract
 * @param {Object} cookiesData - User credentials from cookies
 * @param {Object} contractFormData - Contract form data to insert
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Promise<Object>} - { success: boolean, data: object, error: string }
 */
export const insertContract = async (cookiesData, contractFormData, dispatch) => {
  try {
    const apiHeaders = generateHeader();

    const response = await POSTAPI(false, INSERT_CONTRACT, null, apiHeaders, contractFormData, dispatch);

    // Check if the response indicates success (status from JSON body and ret_code from stored procedure)
    const responseStatus = response?.status === true;
    const retCode = response?.data?.out_parameters?.out_ret_code;
    const isSuccess = responseStatus && retCode === 0;

    if (isSuccess) {
      return {
        success: responseStatus,
        data: response?.data,
        message: response?.msg || "Contract added successfully!",
      };
    } else {
      const errorMsg = response?.data?.out_parameters?.out_error_msg || response?.msg || "Failed to insert contract";
      console.error("Failed to insert contract:", errorMsg);
      return {
        success: false,
        data: null,
        error: errorMsg,
      };
    }
  } catch (error) {
    console.error("Error inserting contract:", error);
    return {
      success: false,
      data: null,
      error: error.message || "An error occurred while inserting the contract",
    };
  }
};
